<template>
  <div class="header-box">
    <div class="header-box-left"></div>
    <div
      class="header-box-right"
      :class="showMenu ? 'menu-off' : 'menu-no'"
      @click="taggerMeun"
    ></div>
    <el-collapse-transition>
      <div class="menu-list" v-if="showMenu">
        <div
          class="menu-item"
          v-for="(item, index) in menuList"
          :key="'menu' + index"
          @click="toUrl(item)"
        >
          <div>{{ item.title }}</div>
          <i
            class="menu-icon"
            :class="
              item.showChild ? 'el-icon-caret-bottom' : 'el-icon-caret-right'
            "
            v-if="item.child"
          ></i>
          <template v-if="item.child && item.showChild">
            <div
              class="two-menu-item"
              v-for="(itemTwo, twoIndex) in item.child"
              @click.stop="toUrl(itemTwo)"
            >
              <div class="two-menu-item-title">{{ itemTwo.name }}</div>
              <div
                class="sub_new_nav_list"
                v-if="itemTwo.subNodes && itemTwo.subNodes.length > 0"
              >
                <template v-for="item1 in itemTwo.subNodes">
                  <div class="sub-new-nav-list-item">{{ item1.name }}</div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="menu-item" @click="loginOut">
          <div>退出</div>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
export default {
  name: "mheader",
  data() {
    return {
      showMenu: false,
      usertype: this.$store.state.usertype,
      menuPath: this.$store.state.menuPath
        ? this.$store.state.menuPath.split(",")
        : [],
      menuList: [],
      productGroup: [],
      innovationGroup: []
    };
  },
  computed: {},
  created() {
    this.getMenuList();
  },
  methods: {
    loginOut() {
      this.$router.push({
        name: "login"
      });
    },
    getMenuList() {
      let menuLists = [];
      if (
        this.menuPath.includes("/product") ||
        this.menuPath.includes("/product/Category")
      ) {
        let menuListItem = {
          title: "产品",
          showChild: false,
          child: []
        };
        if (this.menuPath.includes("/product")) {
          menuListItem.child.push({
            name: "产品线",
            url: "productCategory"
          });
        }
        if (this.menuPath.includes("/product/Category")) {
          menuListItem.child.push({
            name: "产品型号",
            url: "product"
          });
        }
        menuLists.push(menuListItem);
      }
      if (
        this.menuPath.includes("/component") ||
        this.menuPath.includes("/component/group")
      ) {
        let menuListItem = {
          title: "物料",
          showChild: false,
          child: []
        };
        if (this.menuPath.includes("/component")) {
          menuListItem.child.push({
            name: "物料",
            url: "component"
          });
        }
        if (this.menuPath.includes("/component/group")) {
          menuListItem.child.push({
            name: "物料分组",
            url: "componentGroup"
          });
        }
        menuLists.push(menuListItem);
      }
      if (
        this.menuPath.includes("/requirement") ||
        this.menuPath.includes("/requirement/config")
      ) {
        let menuListItem = {
          title: "需配",
          showChild: false,
          child: []
        };
        if (this.menuPath.includes("/requirement")) {
          menuListItem.child.push({
            name: "需求提交",
            url: "requirement"
          });
        }
        if (this.menuPath.includes("/requirement/config")) {
          menuListItem.child.push({
            name: "配置方案",
            url: "requirementConfig"
          });
        }
        menuLists.push(menuListItem);
      }
      if (this.menuPath.includes("/quotation")) {
        menuLists.push({
          title: "报价",
          url: "quotationList"
        });
      }
      if (
        this.menuPath.includes("/quotation/approval") ||
        this.menuPath.includes("/plan/pick-material") ||
        this.menuPath.includes("/plan/produce") ||
        this.menuPath.includes("/plan/initial-inspection") ||
        this.menuPath.includes("/plan/preburning") ||
        this.menuPath.includes("/plan/final-inspection") ||
        this.menuPath.includes("/plan/package") ||
        this.menuPath.includes("/plan/transport")
      ) {
        let menuListItem = {
          title: "智造",
          showChild: false,
          child: []
        };
        if (this.menuPath.includes("/quotation/approval")) {
          menuListItem.child.push({
            name: "审核",
            url: "examine"
          });
        }
        if (this.menuPath.includes("/plan/pick-material")) {
          menuListItem.child.push({
            name: "领料",
            url: "picking"
          });
        }
        if (this.menuPath.includes("/plan/produce")) {
          menuListItem.child.push({
            name: "生产装配",
            url: "productionAssembly"
          });
        }
        if (this.menuPath.includes("/plan/initial-inspection")) {
          menuListItem.child.push({
            name: "初检",
            url: "newInspect"
          });
        }
        if (this.menuPath.includes("/plan/preburning")) {
          menuListItem.child.push({
            name: "老化",
            url: "oldInspect"
          });
        }
        if (this.menuPath.includes("/plan/final-inspection")) {
          menuListItem.child.push({
            name: "终检",
            url: "endInspect"
          });
        }
        if (this.menuPath.includes("/plan/package")) {
          menuListItem.child.push({
            name: "包装",
            url: "package"
          });
        }
        if (this.menuPath.includes("/plan/transport")) {
          menuListItem.child.push({
            name: "物流",
            url: "logistics"
          });
        }
        menuLists.push(menuListItem);
      }
      if (this.menuPath.includes("/productReport")) {
        menuLists.push({
          title: "生产月报",
          url: "productReport"
        });
      }
      let systemListItem = {
        title: "系统管理",
        showChild: false,
        child: [
          {
            name: "个人资产",
            url: "personalAssets"
          }
        ]
      };
      if (this.menuPath.includes("/user")) {
        systemListItem.child.push({
          name: "用户管理",
          url: "user"
        });
      }
      if (this.menuPath.includes("/system")) {
        systemListItem.child.push({
          name: "配置管理",
          url: "system"
        });
      }
      if (this.menuPath.includes("/role")) {
        systemListItem.child.push({
          name: "角色管理",
          url: "role"
        });
      }
      if (this.menuPath.includes("/sysLog")) {
        systemListItem.child.push({
          name: "日志",
          url: "log"
        });
      }
      menuLists.push(systemListItem);
      this.menuList = menuLists;
    },
    taggerMeun() {
      this.showMenu = !this.showMenu;
    },
    toUrl(item) {
      if (item.child && item.child.length > 0) {
        item.showChild = !item.showChild;
      } else {
        this.showMenu = false;
        this.$router.push({
          name: item.url
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.header-box {
  display: flex;
  height: 50px;
  background-color: #951d1d;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .header-box-left {
    width: 22%;
    height: 100%;
    background: url("../assets/images/logo.png") no-repeat center;
    background-size: 72%;
  }

  .header-box-right {
    font-family: "Glyphicons Halflings";
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    font-size: 22px;
    margin-right: 20px;
  }

  .menu-off {
    &::before {
      content: "✖";
      color: #cccccc;
    }
  }

  .menu-no {
    &::before {
      content: "☰";
      color: #cccccc;
    }
  }

  .menu-list {
    position: absolute;
    width: calc(100% - 60px);
    top: 50px;
    background: whitesmoke;
    text-indent: 18px;
    height: calc(100vh - 50px);
    z-index: 99;
    overflow-y: auto;
    padding: 0 30px;

    .menu-item {
      line-height: 42px;
      border-bottom: 1px solid gainsboro;
      position: relative;

      .menu-icon {
        position: absolute;
        top: 14px;
        right: 15px;
      }

      .two-menu-item {
        width: 100%;
        margin-bottom: 3px;
        font-size: 12px;

        .two-menu-item-title {
          display: block;
          padding: 2%;
          line-height: 20px;
          font-size: 14px;
          border-top: 1px solid gainsboro;
          color: black;
        }

        .sub_new_nav_list {
          line-height: 1.42857143;
          padding-top: 4px;
          display: flex;
          flex-wrap: wrap;

          .sub-new-nav-list-item {
            font-size: 12px;
            margin: 0 7px 4px 6px;
            color: gray;
            line-height: 1.42857143;
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileHeaderNav.vue